// src/components/tabs/OthersTab.tsx
import React from 'react';

type ImageAsset = { file?: string };

interface OtherTabContent {
    title?: string;
    description?: string;
    image?: ImageAsset;
}

interface OtherTab {
    title?: string;
    content?: OtherTabContent[];
    mainImage?: ImageAsset;
}

interface ProcessedTripItinerary {
    mainImage?: ImageAsset;
}

interface ProcessedTourOperator {
    logoContrast?: ImageAsset;
    name?: string;
}

interface OthersTabProps {
    tourPackage: ProcessedTripItinerary;
    operatorColor?: string;
    isMobile?: boolean;
    tourOperator: ProcessedTourOperator;
    otherTab: OtherTab;
}

export const OthersTab: React.FC<OthersTabProps> = ({ tourPackage, tourOperator, otherTab }) => {
    const contents = otherTab.content ?? [];

    return (
        <div className="flex flex-col md:flex-row w-full items-stretch md:max-h-screen md:overflow-y-auto bg-[#F7F6F2]">
            {/* Mobile: Content below image, Desktop: Content on left */}
            <div className="order-last md:order-first w-full md:w-[50%] flex flex-col ">
                <div
                    id="obsContainer"
                    className="w-full bg-[#F7F6F2] p-4 md:p-8 text-left md:pt-16 md:px-[70px]"
                >
                    <div className="mb-4">
                        <div className="flex flex-row items-center justify-between">
                        <div className="text-xl md:text-2xl font-semibold md:font-black mb-1 mt-10">
                            {otherTab.title}
                        </div>
                        {
                            otherTab.titleImage && (
                                <img
                                    src={otherTab.titleImage.file || ''}
                                    alt={otherTab.title || 'Title Image'}
                                    className="max-w-[100px] h-auto object-cover rounded-2xl mt-4 mb-10"
                                />
                            )
                        }
                        </div>

                        {contents.length > 0 &&
                            contents.map((content: OtherTabContent, idx: number) => (
                                <div key={idx}>
                                    <div className="text-lg font-normal md:font-semibold mb-4 mt-6">{content.title}</div>
                                    <div className="text-sm">{content.description}</div>
                                    {content.image && (
                                        <img
                                            src={content.image.file || ''}
                                            alt={content.title || 'Image'}
                                            className="w-full h-auto object-cover rounded-2xl mt-4 mb-10"
                                        />
                                    )}
                                </div>
                            ))}
                    </div>

                    <div className="mt-6 mb-16">
                        <div className="h-full flex flex-col gap-[45px] gap-y-[20px] mt-0 w-full flex-wrap justify-start items-start content-start" />
                    </div>
                </div>
            </div>

            {/* Mobile: Image on top, Desktop: Image on right (fills column height) */}
            <div className="order-first md:order-last w-full md:w-[70%] h-[200px] md:h-auto md:flex md:flex-col">
                <div className="relative md:flex-1">
                    <img
                        src={otherTab.mainImage?.file || tourPackage.mainImage?.file || ''}
                        alt="Observaciones"
                        className="w-full h-full object-cover rounded-b-2xl md:rounded-r-none md:rounded-l-2xl"
                    />
                    <img
                        src={tourOperator.logoContrast?.file || ''}
                        className="w-40 absolute hidden md:block bottom-4 right-4"
                        alt={tourOperator.name}
                    />
                </div>
            </div>
        </div>
    );
};
